module.exports = __webpack_public_path__ + "media/newstyle/images/a5-e84b6c6e8757d7affd835a2d9159a301.svg";